import React from 'react';
import { Rocket, Users, Award, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const stats = [
    { icon: Rocket, value: '50+', label: t.about.stats.appsLaunched },
    { icon: Users, value: '2M+', label: t.about.stats.activeUsers },
    { icon: Award, value: '15+', label: t.about.stats.awardsWon },
    { icon: Globe, value: '30+', label: t.about.stats.countriesReached },
  ];

  return (
    <section id="about" className="bg-[#302f2c] py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#888680] text-sm font-semibold uppercase tracking-widest mb-4 block">
              {t.about.label}
            </span>
            <h2 className="font-black text-[#7dd3fc] uppercase leading-[0.85] mb-8" style={{ fontSize: 'clamp(2.5rem, 3.5vw + 1rem, 4.5rem)' }}>
              {t.about.headline}
            </h2>
            <div className="space-y-5">
              <p className="text-[#7dd3fc]/80 text-lg leading-relaxed">
                {t.about.paragraph1}
              </p>
              <p className="text-[#888680] text-base leading-relaxed">
                {t.about.paragraph2}
              </p>
              <p className="text-[#888680] text-base leading-relaxed">
                {t.about.paragraph3}
              </p>
            </div>
          </div>

          {/* Right - Stats Grid */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat) => {
              const IconComponent = stat.icon;
              return (
                <div 
                  key={stat.label}
                  className="bg-[#1a1c1b] border border-[#1e3a5f]/50 p-8 text-center group hover:border-[#7dd3fc]/50 transition-all duration-300"
                >
                  <IconComponent className="w-10 h-10 text-[#7dd3fc] mx-auto mb-4 group-hover:scale-110 transition-transform" />
                  <div className="text-[#7dd3fc] font-black text-4xl md:text-5xl mb-2">
                    {stat.value}
                  </div>
                  <div className="text-[#888680] text-sm font-medium uppercase tracking-wider">
                    {stat.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -left-20 top-1/4 w-40 h-40 bg-[#7dd3fc]/5 rounded-full blur-3xl" />
      <div className="absolute -right-20 bottom-1/4 w-60 h-60 bg-[#1e3a5f]/30 rounded-full blur-3xl" />
    </section>
  );
};

export default AboutSection;
